var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.1765,
    height: 27.1765,
    rx: 13.5883,
    fill: "#B73D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0482 9.13503C17.7721 8.85896 17.3261 8.85896 17.0501 9.13503L13.5885 12.5895L10.127 9.12795C9.85096 8.85188 9.405 8.85188 9.12893 9.12795C8.85286 9.40402 8.85286 9.84998 9.12893 10.1261L12.5904 13.5876L9.12893 17.0491C8.85286 17.3251 8.85286 17.7711 9.12893 18.0472C9.405 18.3232 9.85096 18.3232 10.127 18.0472L13.5885 14.5857L17.0501 18.0472C17.3261 18.3232 17.7721 18.3232 18.0482 18.0472C18.3242 17.7711 18.3242 17.3251 18.0482 17.0491L14.5866 13.5876L18.0482 10.1261C18.3171 9.85706 18.3171 9.40402 18.0482 9.13503Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRow);
export default __webpack_public_path__ + "static/media/deleteRow.789c14c28333ca5d8f9f0bd27928d273.svg";
export { ForwardRef as ReactComponent };